module.exports = __webpack_public_path__ + "fonts/roboto-bold.6490694.eot";